import React from 'react';

/**
 * Port of kaneai's InstructionIconV4 subset — the commands kane-cli packs
 * actually contain. All SVGs quoted verbatim from the source (16×16,
 * strokeWidth 1.5). Color by status: passed #1A7F37, failed → the red
 * warning triangle overrides EVERY glyph (kaneai rule), pending grey
 * #6E7781, default #666666.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var colorFor = function colorFor(status) {
  if (status === 'passed') return '#1A7F37';
  if (status === 'failed') return '#CF222E';
  if (status === 'skipped' || status === 'autoplay_pending' || status === 'executing') {
    return '#6E7781';
  }
  if (status === 'disabled') return '#8C959F';
  return '#666666';
};
var WarningTriangle = function WarningTriangle() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-label": "Step failed",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8 2.5L14 13.5H2L8 2.5Z",
      stroke: "#CF222E",
      strokeWidth: "1.25",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 7V9.5",
      stroke: "#CF222E",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "8",
      cy: "11.5",
      r: "0.75",
      fill: "#CF222E"
    })]
  });
};
var Navigate = function Navigate(_ref) {
  var c = _ref.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.0824 4.1171L8.03541 3.16398C9.39988 1.79951 11.6121 1.79951 12.9766 3.16398C14.3411 4.52845 14.3411 6.7407 12.9766 8.10517L12.0236 9.05829",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.05892 12.0232L8.1059 12.9763C6.74143 14.3408 4.52918 14.3408 3.16471 12.9763C1.80024 11.6119 1.80024 9.39962 3.16471 8.03515L4.11772 7.08203",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.55322 6.58789L6.5885 9.55261",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
var Click = function Click(_ref2) {
  var c = _ref2.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.88257 6.04102L9.26482 14.1584L10.4824 10.6409L14 9.42327L5.88257 6.04102Z",
      fill: c,
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.66699 1.44141L5.20815 3.40311",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.69217 5.54355L1.87402 5.04199",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.26989 3.09766L8.01599 4.28886",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.2504 8.05078L3.0592 9.30468",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};
var Type = function Type(_ref3) {
  var c = _ref3.c;
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 5.06248V3H13.9999V5.06248M5.74997 13.9999H10.2499M7.99995 3V13.9999",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
var Assertion = function Assertion(_ref4) {
  var c = _ref4.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 8.5L6 12.5L14 3.5",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 6L13 3.5",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};
var TextBeam = function TextBeam(_ref5) {
  var c = _ref5.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4 2H12",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 2V14",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.5 14H10.5",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};

/** kaneai sendkeys glyph (keyboard) — quoted from InstructionIconV4. */
var SendKeys = function SendKeys(_ref6) {
  var c = _ref6.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "4",
      y: "1.5",
      width: "8",
      height: "6",
      rx: "1",
      stroke: c,
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 4.5V5.5",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("rect", {
      x: "1",
      y: "9",
      width: "14",
      height: "5",
      rx: "1",
      stroke: c,
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("line", {
      x1: "4",
      y1: "11.5",
      x2: "12",
      y2: "11.5",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};

/** kaneai vision_query glyph (eye) — quoted from InstructionIconV4. */
var VisionQuery = function VisionQuery(_ref7) {
  var c = _ref7.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z",
      stroke: c,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "8",
      cy: "8",
      r: "2.5",
      stroke: c,
      strokeWidth: "1.5"
    })]
  });
};
var DefaultCheck = function DefaultCheck(_ref8) {
  var c = _ref8.c;
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.7613 4.21934C13.9017 4.35997 13.9806 4.55059 13.9806 4.74934C13.9806 4.94809 13.9017 5.13871 13.7613 5.27934L6.51127 12.5293C6.37064 12.6698 6.18002 12.7487 5.98127 12.7487C5.78252 12.7487 5.59189 12.6698 5.45127 12.5293L2.20127 9.27934C2.06886 9.13708 1.99676 8.94903 2.00011 8.75471C2.00347 8.56039 2.08202 8.37494 2.21927 8.23734C2.35687 8.1001 2.54232 8.02154 2.73664 8.01818C2.93095 8.01483 3.11901 8.08693 3.26127 8.21934L5.98127 10.9393L12.7013 4.21934C12.8419 4.07889 13.0325 4 13.2313 4C13.43 4 13.6206 4.07889 13.7613 4.21934Z",
      fill: c
    })
  });
};

/** kaneai v4 assets/SparkleIcon — the GENERATIVE BLOCK header glyph
 * (circular swirl + spark burst), quoted verbatim. Completed → green,
 * error → red, default blue. */
export var GenerativeIcon = function GenerativeIcon(_ref9) {
  var status = _ref9.status;
  var color = status === 'block-error' ? '#D1242F' : status === 'block-completed' ? '#1A7F37' : '#0969DA';
  return /*#__PURE__*/_jsxs("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.625 8.125C15.625 12.2671 12.2671 15.625 8.125 15.625C3.98286 15.625 0.625 12.2671 0.625 8.125C0.625 4.19498 3.64777 0.970959 7.49518 0.651071C7.70283 0.633805 7.91289 0.625 8.125 0.625M12.4108 8.1249C12.4108 10.4918 10.4921 12.4106 8.12513 12.4106C5.7582 12.4106 3.83942 10.4918 3.83942 8.1249C3.83942 5.75797 5.7582 3.83919 8.12513 3.83919",
      stroke: color,
      strokeWidth: "1.25",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.12525 7.98857L10.0379 6.03656M10.0379 6.03656L10.014 3.33449M10.0379 6.03656L11.625 4.52866M10.0379 6.03656L11.3655 6.24462M10.014 3.33449C10.0138 3.30966 10.0242 3.28592 10.0425 3.2692L10.6024 2.75908M10.014 3.33449L11.625 4.52866M12.6005 3.60023L12.6013 3.60108M12.6005 3.60023L12.8771 6.48151M12.6005 3.60023L12.3255 1.45819M12.6013 3.60108L15.0723 4.16097C15.0789 4.16245 15.0814 4.1705 15.0768 4.17543L14.125 5.19765M12.6013 3.60108L12.2821 3.90433M12.8771 6.48151C12.9058 6.486 12.9348 6.47597 12.9545 6.45476L14.125 5.19765M12.8771 6.48151L11.9459 6.33558M11.625 4.52866L12.2821 3.90433M11.1623 2.24896L12.2821 1.22871C12.2874 1.22396 12.2958 1.22705 12.2967 1.23405L12.3255 1.45819M11.1623 2.24896L12.2821 3.90433M11.1623 2.24896L10.6024 2.75908M10.6024 2.75908L14.125 5.19765M10.6024 2.75908L11.3655 6.24462M11.9459 6.33558L12.3255 1.45819M11.9459 6.33558L11.3655 6.24462",
      stroke: color,
      strokeWidth: "1.08218",
      strokeLinecap: "round"
    })]
  });
};

/** kaneai SparkleIcon — no-command leaves. */
export var SparkleIcon = function SparkleIcon(_ref0) {
  var status = _ref0.status;
  var c = status === 'failed' || status === 'block-error' ? '#D1242F' : status === 'passed' || status === 'block-completed' ? '#1A7F37' : status === 'autoplay_pending' || status === 'skipped' || status === 'disabled' ? '#6E7781' : '#0969DA';
  return /*#__PURE__*/_jsxs("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.5 2.5C8.5 5.81371 5.81371 8.5 2.5 8.5C5.81371 8.5 8.5 11.1863 8.5 14.5C8.5 11.1863 11.1863 8.5 14.5 8.5C11.1863 8.5 8.5 5.81371 8.5 2.5Z",
      stroke: c,
      strokeWidth: "1.25",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.5 1.5C13.5 2.60457 12.6046 3.5 11.5 3.5C12.6046 3.5 13.5 4.39543 13.5 5.5C13.5 4.39543 14.3954 3.5 15.5 3.5C14.3954 3.5 13.5 2.60457 13.5 1.5Z",
      stroke: c,
      strokeWidth: "1.08218",
      strokeLinejoin: "round"
    })]
  });
};

/** kaneai InstructionIconV4 'api' — the "API" letters glyph. */
var ApiGlyph = function ApiGlyph(_ref1) {
  var c = _ref1.c;
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.01624 12.911V5.05382C8.00195 4.28239 8.61624 3.63953 9.38767 3.62524C9.4091 3.62524 9.43053 3.62524 9.44482 3.62524H10.8734C11.6448 3.61096 12.2877 4.22525 12.302 4.99668C12.302 5.01811 12.302 5.03954 12.302 5.05382V7.1967C12.3163 7.96813 11.702 8.61099 10.9305 8.62528C10.9091 8.62528 10.8877 8.62528 10.8734 8.62528H8.01624",
      stroke: c,
      strokeWidth: "1.25",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.1144 3V13.0001",
      stroke: c,
      strokeWidth: "1.25",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.828735 12.911V5.05382C0.81445 4.28239 1.42874 3.63953 2.20017 3.62524C2.2216 3.62524 2.24303 3.62524 2.25732 3.62524H3.6859C4.45733 3.61096 5.10019 4.22525 5.11448 4.99668C5.11448 5.01811 5.11448 5.03954 5.11448 5.05382V12.911M0.828753 7.911H5.11449",
      stroke: c,
      strokeWidth: "1.25",
      strokeLinejoin: "round"
    })]
  });
};

/** Icon for a leaf's command, colored by its (display) status. Failed steps
 * ALWAYS show the red warning triangle — the kaneai rule. */
export function CommandIcon(_ref10) {
  var command = _ref10.command,
    status = _ref10.status;
  if (status === 'failed') return /*#__PURE__*/_jsx(WarningTriangle, {});
  var c = colorFor(status);
  var key = (command !== null && command !== void 0 ? command : '').toLowerCase();
  if (!key) return /*#__PURE__*/_jsx(SparkleIcon, {
    status: status
  });
  if (key === 'navigate' || key === 'nv' || key === 'open' || key === 'op') {
    return /*#__PURE__*/_jsx(Navigate, {
      c: c
    });
  }
  if (key === 'click' || key === 'cl') return /*#__PURE__*/_jsx(Click, {
    c: c
  });
  if (key === 'api') return /*#__PURE__*/_jsx(ApiGlyph, {
    c: c
  });
  // 'fill' / 'press_key' / 'assert' / 'analyze' are result.yaml kinds —
  // the result-only fallback passes them when no exec command exists.
  if (key === 'type' || key === 'tp' || key === 'fill') {
    return /*#__PURE__*/_jsx(Type, {
      c: c
    });
  }
  if (key === 'sendkeys' || key === 'press_key') return /*#__PURE__*/_jsx(SendKeys, {
    c: c
  });
  if (key === 'vision_query') return /*#__PURE__*/_jsx(VisionQuery, {
    c: c
  });
  if (key === 'assertion' || key === 'assert') return /*#__PURE__*/_jsx(Assertion, {
    c: c
  });
  if (key === 'textual_query' || key === 'textual_analyzer' || key === 'analyze') {
    return /*#__PURE__*/_jsx(TextBeam, {
      c: c
    });
  }
  return /*#__PURE__*/_jsx(DefaultCheck, {
    c: c
  });
}

/** kaneai assert-result icons (quoted). */
export var AssertionCheckIcon = function AssertionCheckIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3 8.5L6.5 12L13 4",
      stroke: "#1A7F37",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
export var AssertionXIcon = function AssertionXIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4 4L12 12M12 4L4 12",
      stroke: "#CF222E",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/** Autoplay header button glyphs (quoted from InteractionButtonSvg). */
export var PlayIcon = function PlayIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4 12.1014C4 12.4247 4.35708 12.6202 4.62896 12.4454L12.5375 7.36093C12.7897 7.19881 12.7897 6.83035 12.5375 6.66823L4.62896 1.58375C4.35708 1.40895 4 1.60443 4 1.92775V12.1014Z",
      transform: "translate(0 1)",
      fill: "#6E7781"
    })
  });
};
export var PauseIcon = function PauseIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.5 12.5L5.5 3.5",
      stroke: "#59636e",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.5 12.5L11.5 3.5",
      stroke: "#59636e",
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  });
};